/* Naughty Hut mega menu, 2026-09-25. No dependencies.
   2026-09-26 (backported from live 2026-09-28): focus returns to the trigger after Escape (menu panel, phone
   drawer, cart drawer) and after the drawer's Back button (WCAG 2.4.3). */
(function () {
  'use strict';
  /* SWITCH_DELAY (2026-09-28, hover intent): with a panel open, another top item only takes over after the
     pointer rests on it. Moving diagonally from a right-hand item (Gift Sets, Brands) down to a link on the
     left crosses the other top items; with a 0 ms switch the panel changed under the pointer and the link
     could not be clicked. */
  /* ---------------- desktop ---------------- */
  /* 2026-09-29 (creative-director): hover intent rebuilt.
     - A panel opens ~170 ms after the pointer really moves over a top item (OPEN_DELAY), not on mouseenter alone.
       "Really moves" = the event carries movement (movementX/Y). Chrome's synthetic mousemove after a popup,
       drawer or layout change under a resting pointer has none, so the D-48 case (a panel opening by itself
       when the Klaviyo popup closes) stays fixed.
     - Arming no longer depends on mouseenter. Before, a pointer that was already over an item when this
       deferred script attached (slow loads) never armed, and the item needed a leave + re-enter.
     - Touch or pen taps on hover-capable laptops: the first tap opens the panel, the second follows the link
       (their compatibility mousemove has no movement, so the tap used to navigate straight away).
     - Panels are capped to the space under the header (minus the Shopify preview bar) and scroll inside. */
  var OPEN_DELAY = 170, CLOSE_DELAY = 300, SWITCH_DELAY = 180;
  var nav = document.querySelector('[data-nhm]');
  var scrim = document.querySelector('[data-nhm-scrim]');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  /* Focus after the current event has finished: other Escape handlers (Impulse's search drawer calls
     document.activeElement.blur()) run after ours and used to drop focus back to <body>. */
  var focusSoon = function (el) {
    if (!el || !el.focus) return;
    var go = function () { if (el.isConnected && document.activeElement !== el) el.focus({ preventScroll: true }); };
    setTimeout(go, 0); setTimeout(go, 60);
  };

  if (nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-nhm-item]'));
    var current = null, pending = null, openT = null, closeT = null;

    /* fit the open panel into the space left under the header, above the preview bar */
    var fit = function (panel) {
      var top = panel.getBoundingClientRect().top, vh = window.innerHeight, bar = 0;
      ['preview-bar-iframe', 'PBarNextFrameWrapper'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < vh && r.bottom > vh - 4 && getComputedStyle(el).visibility !== 'hidden') bar = Math.max(bar, vh - r.top);
      });
      panel.style.setProperty('--nhm-top', Math.round(top) + 'px');
      panel.style.maxHeight = Math.max(240, Math.floor(vh - top - bar - 24)) + 'px';
      panel.classList.toggle('is-scroll', panel.scrollHeight > panel.clientHeight + 2);
    };

    var wanted = null;
    var reveal = function (item) {
      if (current === item) return;
      pending = null;
      var swapping = !!current;
      /* one overlay at a time (QA fix A, FE-10): opening a panel closes the search suggestions */
      if (!current) document.dispatchEvent(new CustomEvent('nh:overlay-open', { detail: { source: 'mega' } }));
      if (current) hide(current, true);
      var panel = item.querySelector('[data-nhm-panel]');
      var top = item.querySelector('[data-nhm-top]');
      /* switching between panels swaps in place (no fade), so there is never a blank frame */
      panel.classList.toggle('is-swap', swapping);
      panel.hidden = false;
      panel.scrollTop = 0;
      fit(panel);
      void panel.offsetWidth; /* force reflow so the fade-in runs without rAF */
      panel.classList.add('is-visible');
      item.classList.add('is-open');
      top.setAttribute('aria-expanded', 'true');
      if (scrim) {
        var hdr = document.getElementById('SiteHeader') || nav;
        scrim.style.top = Math.max(0, hdr.getBoundingClientRect().bottom) + 'px';
        scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('is-visible');
      }
      current = item;
    };
    var show = function (item, then) { wanted = item; reveal(item); if (then) then(); };
    var hide = function (item, swapping) {
      var panel = item.querySelector('[data-nhm-panel]');
      var top = item.querySelector('[data-nhm-top]');
      panel.classList.remove('is-visible', 'is-swap');
      panel.hidden = true;
      item.classList.remove('is-open');
      top.setAttribute('aria-expanded', 'false');
      if (!swapping && scrim) { scrim.classList.remove('is-visible'); scrim.hidden = true; }
      if (current === item) current = null;
    };
    var clearT = function () { clearTimeout(openT); clearTimeout(closeT); };
    var closeAll = function () { clearT(); pending = null; wanted = null; if (current) hide(current); };
    var arm = function (item) {
      if (pending === item) return;
      clearT();
      pending = item;
      openT = setTimeout(function () { if (pending === item) show(item); }, current ? SWITCH_DELAY : OPEN_DELAY);
    };

    items.forEach(function (item, i) {
      var top = item.querySelector('[data-nhm-top]');
      var touchTap = false;
      if (canHover) {
        item.addEventListener('mousemove', function (e) {
          if (e.movementX === 0 && e.movementY === 0) return; /* synthetic move under a resting pointer */
          if (current === item) { clearTimeout(closeT); pending = null; return; }
          arm(item);
        });
        item.addEventListener('mouseleave', function () {
          if (pending === item) pending = null;
          if (wanted === item && current !== item) wanted = null;
          clearT();
          closeT = setTimeout(function () {
            /* keep the panel open while someone is typing in the brand finder */
            var ae = document.activeElement;
            if (ae && ae.tagName === 'INPUT' && current && current.contains(ae)) return;
            /* ...or while keyboard focus is inside it (a mouse drifting off must not pull the panel from under a keyboard user) */
            if (ae && current && current.contains(ae) && ae.matches && ae.matches(':focus-visible')) return;
            /* close whichever panel is open (it may belong to the item the pointer passed over on the way out) */
            if (current) hide(current);
          }, CLOSE_DELAY);
        });
        top.addEventListener('pointerdown', function (e) { touchTap = e.pointerType === 'touch' || e.pointerType === 'pen'; });
        top.addEventListener('click', function (e) {
          if (touchTap && current !== item) { e.preventDefault(); clearT(); show(item); }
          touchTap = false;
        });
      } else {
        /* touch laptops / tablets at >=990px: first tap opens, second tap follows the link */
        top.addEventListener('click', function (e) {
          if (current !== item) { e.preventDefault(); show(item); }
        });
      }
      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault(); clearT();
          show(item, function () { var first = item.querySelector('[data-nhm-panel] input, [data-nhm-panel] a'); if (first) first.focus({ preventScroll: true }); });
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = items[(i + (e.key === 'ArrowRight' ? 1 : items.length - 1)) % items.length];
          if (current) show(n);
          n.querySelector('[data-nhm-top]').focus();
        }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { if (current === item) hide(item); }
      });
    });
    /* Capture phase on window: Impulse's document-level Escape handler (search drawer) blurs the focused
       element, which fired our focusout handler and cleared `current` before this code could run.
       A brand-finder input that still has text keeps its own Escape (clear the text) behaviour. */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !current) return;
      var tg = e.target;
      if (tg && tg.matches && tg.matches('[data-nhb-input]') && tg.value) return;
      var t = current.querySelector('[data-nhm-top]'); closeAll(); t.focus(); focusSoon(t);
    }, true);
    if (scrim) scrim.addEventListener('click', closeAll);
    document.addEventListener('nh:overlay-open', function (e) { if (!e.detail || e.detail.source !== 'mega') closeAll(); });
    window.addEventListener('resize', function () {
      if (window.innerWidth < 990) { closeAll(); return; }
      if (current) fit(current.querySelector('[data-nhm-panel]'));
    });
  }

  /* ---------------- mobile drawer ---------------- */
  var drawer = document.querySelector('[data-nhd]');
  if (!drawer) return;
  var openers = document.querySelectorAll('[data-nhd-open]');
  var lastFocus = null;
  var views = drawer.querySelectorAll('[data-nhd-panel]');
  var showView = function (id, dir) {
    Array.prototype.forEach.call(views, function (v) {
      var on = v.getAttribute('data-nhd-panel') === id;
      v.hidden = !on;
      v.classList.remove('is-enter', 'is-back');
      if (on) { v.scrollTop = 0; v.classList.add(dir === 'back' ? 'is-back' : 'is-enter'); }
    });
  };
  var openDrawer = function () {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    showView('root');
    document.documentElement.classList.add('nhd-lock');
    void drawer.offsetWidth; drawer.classList.add('is-open');
    Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'true'); });
    /* focus moves into the dialog, but a tap-opened drawer shows no ring (focusVisible:false; CSS keeps the ring for :focus-visible) */
    var c = drawer.querySelector('[data-nhd-close]'); if (c) { try { c.focus({ focusVisible: false }); } catch (e) { c.focus(); } }
  };
  var closeDrawer = function () {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('nhd-lock');
    Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { drawer.hidden = true; }, 280);
    /* the drawer may have been opened from the hamburger or the dock; if that is hidden now, fall back to any visible opener */
    var back = lastFocus && lastFocus.isConnected && lastFocus.offsetParent !== null ? lastFocus : null;
    if (!back) back = Array.prototype.filter.call(openers, function (b) { return b.offsetParent !== null; })[0] || null;
    if (back) { back.focus(); focusSoon(back); }
  };
  Array.prototype.forEach.call(openers, function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openDrawer(); });
  });
  drawer.addEventListener('click', function (e) {
    var go = e.target.closest('[data-nhd-go]');
    if (go) { showView(go.getAttribute('data-nhd-go')); var bk = drawer.querySelector('[data-nhd-panel="' + go.getAttribute('data-nhd-go') + '"] [data-nhd-back]'); if (bk) bk.focus(); return; }
    var back = e.target.closest('[data-nhd-back]');
    if (back) {
      /* return focus to the row that opened this panel, so Escape and the Tab trap keep working */
      var from = back.closest('[data-nhd-panel]');
      var id = from && from.getAttribute('data-nhd-panel');
      showView('root', 'back');
      var row = id && drawer.querySelector('[data-nhd-go="' + id + '"]');
      if (row && row.offsetParent !== null) { row.focus(); focusSoon(row); } else { var c = drawer.querySelector('[data-nhd-close]'); if (c) c.focus(); }
      return;
    }
    if (e.target.closest('[data-nhd-close]')) { closeDrawer(); }
  });
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(drawer.querySelectorAll('a,button,input'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  /* safety net: if focus ever lands outside the open drawer, Escape still closes it and Tab returns inside */
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open') || drawer.contains(document.activeElement)) return;
    if (e.key === 'Escape') { closeDrawer(); }
    else if (e.key === 'Tab') { var c = drawer.querySelector('[data-nhd-close]'); if (c) { e.preventDefault(); c.focus(); } }
  });
  window.addEventListener('resize', function () { if (window.innerWidth >= 990 && !drawer.hidden) closeDrawer(); });
})();

/* Impulse cart drawer (#CartDrawer): its close() blurs the focused element and only refocuses the opener
   when the drawer was opened by a click on an element carrying aria-expanded. Opened after "Add to cart"
   (ajax) or closed with Escape, focus ended on <body>. Remember the last focused element outside the
   drawer and put focus back there (or on the cart icon) once the drawer has closed. */
(function () {
  'use strict';
  var cd = document.getElementById('CartDrawer');
  if (!cd || !window.MutationObserver) return;
  var lastOutside = null;
  document.addEventListener('focusin', function (e) {
    if (!cd.contains(e.target)) lastOutside = e.target;
  });
  var wasOpen = cd.classList.contains('drawer--is-open');
  new MutationObserver(function () {
    var open = cd.classList.contains('drawer--is-open');
    if (wasOpen && !open) {
      /* Impulse restores its own opener after 500 ms; only step in if focus is still lost */
      setTimeout(function () {
        var ae = document.activeElement;
        if (ae && ae !== document.body && ae !== document.documentElement && !cd.contains(ae)) return;
        var target = lastOutside && lastOutside.isConnected && lastOutside.offsetParent !== null ? lastOutside : null;
        if (!target) target = Array.prototype.filter.call(document.querySelectorAll('.js-drawer-open-cart, a[href$="/cart"]'), function (a) { return a.offsetParent !== null; })[0];
        if (target && target.focus) target.focus({ preventScroll: true });
      }, 560);
    }
    wasOpen = open;
  }).observe(cd, { attributes: true, attributeFilter: ['class'] });
})();
